<template>
  <div>
    <v-layout row wrap>
      <v-flex md8>
        <h1>master bill</h1>
      </v-flex>
      <v-flex md2 class="text-lg-right">
        <el-button
          type="success"
          @click="submit"
          :disabled="this.filteredCharges.length === 0"
        >Submit</el-button>
        <!--  <el-button  type="success" @click="GenerateBillCanvas" :disabled='this.filteredCharges.length === 0'>
         Bill
        </el-button>-->
      </v-flex>
    </v-layout>

    <v-form v-model="valid" ref="form" lazy-validation id="printMe">
      <v-layout row wrap>
        <li :v-for="(item, index) in this.filteredCharges" class="listOfCharges">
          <button @click.prevent="removeCharges(item)">
            <v-icon light>close</v-icon>
          </button>
          <input type="text" name v-model="item.name" :datavalue="item.name" id="detail" disabled>
          <input type="text" name id="qty" v-model="item.amount" :datavalue="item.amount" disabled>

          <div
            class="el-input el-input--medium el-input-group el-input-group--prepend"
            data-value="500"
          >
            <div class="el-input-group__prepend">X</div>
            <input
              :datavalue="item.quantity"
              v-model="item.quantity"
              autocomplete="off"
              size="medium"
              id="charge"
              type="text"
              rows="2"
              @focus="inputFocus"
              class="el-input__inner"
            >
            <!---->
            <!---->
            <!---->
          </div>
          <div
            class="el-input el-input--medium is-disabled el-input-group el-input-group--prepend"
            data-value="222"
          >
            <div class="el-input-group__prepend">₹</div>
            <input
              disabled="disabled"
              autocomplete="off"
              size="medium"
              type="text"
              rows="2"
              validateevent="true"
              @focus="inputFocus"
              :datavalue="item.quantity*item.amount"
              :value="item.quantity*item.amount"
              class="el-input__inner"
            >
            <!---->
            <!---->
            <!---->
          </div>

          <!-- <h1>{{(item.quantity*item.amount)}}</h1> -->
        </li>
      </v-layout>
      <v-layout row wrap v-if="this.filteredCharges.length > 0">
        <v-flex md8 class="text-lg-right">Total</v-flex>
        <v-flex md2 class="text-lg-right">{{this.billingTotals}}</v-flex>
      </v-layout>
      <v-layout row wrap v-if="this.filteredCharges.length > 0">
        <v-flex md8 class="text-lg-right">Due</v-flex>
        <v-flex md2 class="text-lg-right">{{this.due}}</v-flex>
      </v-layout>
      <v-layout row wrap v-if="this.filteredCharges.length > 0">
        <v-flex md8 class="text-lg-right">Excess</v-flex>
        <v-flex md2 class="text-lg-right">{{this.excess}}</v-flex>
      </v-layout>
      <v-layout row wrap v-if="this.filteredCharges.length > 0">
        <v-flex md8 class="text-lg-right">Discount</v-flex>
        <v-flex md2 class="text-lg-right el-input--mini">
          <input
            @focus="inputFocus"
            type="text"
            name
            class="discountInput el-input__inner text-right"
            v-model="discount"
            :datavalue="discount"
          >
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="this.filteredCharges.length > 0">
        <v-flex md8 class="text-lg-right">Amount to be paid</v-flex>
        <v-flex md2 class="text-lg-right">
          <!-- <h1>{{(this.billingTotals - this.discount)}}</h1> -->
          <h1>{{totalTotal}}</h1>
          <!-- <el-input :value='totalTotal' size="mini" class="discountInput"></el-input> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="this.filteredCharges.length > 0">
        <v-flex md8 class="text-lg-right">Total Amount Paid</v-flex>
        <v-flex md2 class="text-lg-right el-input--mini">
          <input
            @focus="inputFocus"
            type="text"
            name
            class="discountInput el-input__inner text-right"
            v-model="totalAmount"
            :datavalue="totalAmount"
          >
        </v-flex>
      </v-layout>
      <!-- <v-btn @click="submit" :disabled="!valid" v-if='this.filteredCharges !== undefined'>
      submit
      </v-btn>-->
    </v-form>
    <v-select
      class="autocompleteSelect"
      v-bind:items="this.charges"
      v-model="a1"
      label="Select"
      return-object
      item-text="name"
      item-value="amount"
      :hint="`${a1.amount}`"
      persistent-hint
      autocomplete
    ></v-select>
    <!-- add -->
    <v-btn @click="addNewCharge" :disabled="this.a1.name.length < 1">Add</v-btn>
    <!-- print -->
    <!-- <v-btn @click="print">
    print
    </v-btn>-->
  </div>
</template>

<script>
import Vue from "vue";
import { api } from "../api.js";
import { mapState } from "vuex";
import { axios, get, post } from "axios";
import _ from "lodash";
import html2canvas from "html2canvas";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  name: "allBills",
  data() {
    return {
      billList: "",
      valid: true,
      a1: {
        name: "",
        amount: ""
      },
      filteredCharges: this.filteredCharges,
      charges: this.charges,
      charges_list: this.charges_list,
      itemTotal: "",
      discount: 0,
      totalAmount: 0,
      due: this.due,
      excess: this.excess
      // tototot: 0
    };
  },
  computed: {
    appId: function() {
      if (this.$route.params.appId !== null) {
        return this.$route.params.appId;
      }
    },
    ptId: function() {
      if (this.$route.params.ptId !== null) {
        return this.$route.params.ptId;
      }
    },
    billingTotals: function() {
      let arr = this.filteredCharges;
      let sumOfitemTotals = 0;
      for (const i in arr) {
        sumOfitemTotals += arr[i].amount * arr[i].quantity;
      }
      return sumOfitemTotals;
    },
    totalTotal: function() {
      const masterTotal =
        this.billingTotals + this.due - this.discount - this.excess;
      return masterTotal;
    }
  },
  mounted() {
    this.getBills();
    this.getCharges();
    // console.log(document.querySelectorAll('.el-input input.el-input__inner'));
  },
  methods: {
    getBills() {
      get(api + `/billings?person_id=${this.ptId}&is_today=true`).then(res => {
        console.log(res);
        this.billList = res.data.bill_list;
      });
    },
    inputFocus() {
      $("#printMe input").on("keydown", e => {
        if (e.keyCode === 13) {
          e.preventDefault();
        }
      });
    },
    getCharges() {
      get(api + `/clinic_charges?person_id=${this.ptId}`).then(res => {
        this.charges = res.data.charge_list;
        this.due = res.data.due;
        this.excess = res.data.excess;
        this.filteredCharges = this.charges.filter(
          charge => charge.is_admission === 1 || charge.is_default === 1
        );
      });
    },
    addNewCharge() {
      this.filteredCharges.push({
        id: this.a1.id,
        name: this.a1.name,
        amount: this.a1.amount,
        quantity: 1
      });
    },
    removeCharges(item) {
      var index = this.filteredCharges.indexOf(item);
      if (index !== -1) {
        this.filteredCharges.splice(index, 1);
      }
    },

    submit() {
      var intAppId = parseInt(this.appId);
      let billingPayload = {
        appointment_id: intAppId,
        master_bill: 1,
        paid: this.totalAmount,
        discount: this.discount,
        fee: []
      };
      this.filteredCharges.forEach(function(item) {
        billingPayload.fee.push({
          id: item.id,
          amount: item.amount,
          quantity: item.quantity
        });
      });
      console.log(billingPayload);
      // POST
      post(api + `/billings`, billingPayload).then(res => {
        console.log(res.data);
        if ((res.data.message = "Bill successfully posted")) {
          // this.$router.push("/dashboard");
          let clinic_id = localStorage.getItem("clinic_id");
          let doctor_id = localStorage.getItem("doctor_id");
          this.$router.push("/dashboard/" + clinic_id + "/" + doctor_id);
        }
      });
    },
    GenerateBillCanvas() {
      html2canvas(document.getElementById("printMe")).then(canvas => {
        console.log(canvas);
        document.body.appendChild(canvas);
      });
    },
    GenerateBill() {
      var printContents = document.getElementById("printMe").innerHTML;
      var HeadContents = document.getElementsByTagName("head")[0].innerHTML;

      printContents = printContents.replace(/datavalue/g, "value");
      const w = window.open();
      //console.log(w.document.getElementsByTagName("head"));
      //w.document.getElementsByTagName("head")[0].innerHTML=HeadContents;
      w.document.write(HeadContents + printContents);
      setTimeout(function() {
        w.print();
      }, 50);

      //w.close();
    },
    print() {
      const doccc = {
        content: [
          {
            table: {
              body: [
                ["Column 1", "Column 2", "Column 3", "Column 4"],
                ["One value goes here", "Another one here", "OK?"]
              ]
            }
          }
        ]
      };
      var docDefinition = doccc;
      pdfMake.createPdf(docDefinition).print();
    }
  }
};
</script>
<style scoped>
.el-input {
  margin: auto;
  width: 150px;
}
</style>


<style lang="css">
#detail {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 30%; */
  margin-left: 2rem;
}

#charge {
  border: 1px solid #d8d8d8;
  /* border-radius: 4px; */
  padding: 8px;
  /* width: 15%; */
  /* margin: 10px; */
}

#qty {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 10%; */
}

.text-right {
  text-align: right;
}
.el-input.el-input-group--prepend.is-disabled {
  margin-left: 1rem;
}
.discountInput {
  width: 100px;
}
.discountInput .el-input__inner {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/masterBill.vue